export function getValuesFromList(list, key = "desc", valueKey = "value") {
  const obj = {};
  (list || []).forEach((item) => {
    const keyValue = item[key] || "";
    const value = item[valueKey];
    if (keyValue && value) {
      obj[keyValue] = value;
    }
  });
  return obj;
}
